import React from 'react';
import { dialOnPhone, usePhone } from './PhonePanel';
import { openConversation } from './phoneNav';
import './reachButtons.css';

// Call on the company line, or Text in Phone & Messages (the shared inbox: app push or SMS, your pick there).
export default function ReachButtons({ phone, ext = '', name = '', trip = null }) {
  const p = usePhone();
  const ready = p.status === 'ready' && !p.call;
  const dial = ext || phone;
  const stop = (e) => e.stopPropagation();
  if (!dial && !phone) return null;
  return (
    <span className="reach-btns" onClick={stop} onKeyDown={stop} role="group" aria-label={`Reach ${name || phone || ext}`}>
      {dial && <button type="button" className="tmw-btn tmw-btn-sm" disabled={!ready} title={ready ? `Call ${name || ''}${ext ? ` (ext. ${ext})` : ''}` : 'Connect your phone first (Phone button at the top)'} onClick={() => dialOnPhone(dial, { label: name || undefined, trip: trip || undefined })}>Call</button>}
      {phone && <button type="button" className="tmw-btn tmw-btn-sm tmw-btn-primary" title={`Text ${name || ''} in Phone & Messages`} onClick={() => openConversation(phone)}>Text</button>}
    </span>
  );
}
